/* assets/trustarc-modal.js
   Fix: trap focus inside TrustArc cookie preferences modal,
   prevent focus from going behind dialog, restore focus on close.
*/
(function () {
  let activeModal = null;
  let lastFocused = null;
  let cleanupFns = [];
  let observerStarted = false;

  const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function isVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
  }

  function getFocusable(container) {
    if (!container) return [];
    return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(isVisible);
  }

  
  function findTrustArcModal() {
    const candidates = Array.from(document.querySelectorAll('div[aria-modal="true"]'));
    for (const el of candidates) {
      const text = (el.innerText || '').toLowerCase();
      if (text.includes('cookie preferences') || el.querySelector('#cookieMainHeader')) {
        return el;
      }
    }
    return candidates.find(isVisible) || null;
  }

  function setBackgroundAriaHidden(modal, hide) {
    const bodyChildren = Array.from(document.body.children);
    bodyChildren.forEach((child) => {
      if (child === modal) return;

      
      if (modal && child.contains(modal)) return;

      if (hide) {
        child.dataset.taAriaHiddenBackup =
          child.getAttribute('aria-hidden') === null ? '' : child.getAttribute('aria-hidden');
        child.setAttribute('aria-hidden', 'true');
      } else {
        if ('taAriaHiddenBackup' in child.dataset) {
          const prev = child.dataset.taAriaHiddenBackup;
          delete child.dataset.taAriaHiddenBackup;

          if (prev === '') child.removeAttribute('aria-hidden');
          else child.setAttribute('aria-hidden', prev);
        } else {
          // don’t touch if we didn’t set it
        }
      }
    });
  }

  function trapTabKey(e, modal) {
    if (e.key !== 'Tab') return;

    const focusables = getFocusable(modal);
    if (!focusables.length) {
      e.preventDefault();
      modal.focus();
      return;
    }

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    // If Shift+Tab on first -> loop to last
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    }
    // If Tab on last -> loop to first
    else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function keepFocusInside(e, modal) {
    // If focus moved outside modal, pull it back
    if (!modal.contains(e.target)) {
      const focusables = getFocusable(modal);
      (focusables[0] || modal).focus();
    }
  }

  function openFix(modal) {
    if (!modal || modal === activeModal) return;

    activeModal = modal;

    // Save where focus came from
    lastFocused = document.activeElement;

    // Make modal focusable if needed
    if (!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex', '-1');

    // Give modal a dialog role if TrustArc didn’t
    if (!modal.getAttribute('role')) modal.setAttribute('role', 'dialog');

    // If there’s no accessible name, add one from header or fallback
    const header = modal.querySelector('#cookieMainHeader') || modal.querySelector('h1,h2,h3');
    if (!modal.getAttribute('aria-label') && !modal.getAttribute('aria-labelledby')) {
      if (header && header.id) modal.setAttribute('aria-labelledby', header.id);
      else modal.setAttribute('aria-label', 'Cookie preferences');
    }

    // Hide background from AT
    setBackgroundAriaHidden(modal, true);

    // Focus first meaningful control or modal itself
    const focusables = getFocusable(modal);
    (focusables[0] || header || modal).focus();

    // Trap tab
    const onKeyDown = (e) => trapTabKey(e, modal);
    const onFocusIn = (e) => keepFocusInside(e, modal);

    document.addEventListener('keydown', onKeyDown, true);
    document.addEventListener('focusin', onFocusIn, true);

    cleanupFns.push(() => document.removeEventListener('keydown', onKeyDown, true));
    cleanupFns.push(() => document.removeEventListener('focusin', onFocusIn, true));
  }

  function closeFix() {
    if (!activeModal) return;

    // Restore background
    setBackgroundAriaHidden(activeModal, false);

    // Remove listeners
    cleanupFns.forEach((fn) => {
      try { fn(); } catch (e) {}
    });
    cleanupFns = [];

    const opener = lastFocused;
    activeModal = null;
    lastFocused = null;

    // Restore focus to opener if still in DOM
    if (opener && document.contains(opener)) {
      opener.focus();
    }
  }

  function startObserver() {
    if (observerStarted) return;
    observerStarted = true;

    const obs = new MutationObserver(() => {
      const modal = findTrustArcModal();

      if (modal && isVisible(modal)) {
        openFix(modal);
      } else {
        
        closeFix();
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'aria-hidden', 'aria-modal'] });


    const initial = findTrustArcModal();
    if (initial && isVisible(initial)) openFix(initial);
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }


  window.onTrustArcOpen = function () {
    const modal = findTrustArcModal();
    if (modal) openFix(modal);
  };
  window.onTrustArcClose = function () {
    closeFix();
  };
})();
